/**
 * Top-level skeleton for Doowii Dossier — auth gate, route table, and
 * the global providers everything else hangs off of.
 */

import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CookiesProvider, useCookies } from 'react-cookie';

import { Root } from './pages/Root';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage/Loadable';
import { MalloyQueryPage } from './pages/MalloyQueryPage/Loadable';
import { SentinelPage } from './pages/SentinelPage/Loadable';
import { CatalogPage } from './pages/CatalogPage/Loadable';
import { HealthPage } from './pages/HealthPage/Loadable';
import { LangSmithPage } from './pages/LangSmithPage/Loadable';
import { MagePage } from './pages/MagePage/Loadable';
import { SettingsPage } from './pages/SettingsPage/Loadable';
import { TenantsPage } from './pages/TenantsPage/Loadable';
import * as Constants from './constants';

export function App() {
  const [cookies] = useCookies([Constants.LOGGED_IN_FLAG_COOKIE]);
  const isLoggedIn =
    cookies.__djlif || process.env.REACT_DISABLE_AUTH === 'true';

  return (
    <CookiesProvider>
      <BrowserRouter>
        {isLoggedIn ? (
          <>
            <Helmet
              titleTemplate="Doowii Dossier: %s"
              defaultTitle="Doowii Dossier"
            >
              <meta
                name="description"
                content="Doowii Dossier — explore Malloy semantic models, dbt lineage, and data quality checks."
              />
            </Helmet>
            <Routes>
              <Route
                path="/"
                element={<Root />}
                children={
                  <>
                    <Route path="/" element={<CatalogPage />} key="catalog" />
                    <Route path="build" element={<MalloyQueryPage />} key="build" />
                    <Route path="build/:project/:model" element={<MalloyQueryPage />} key="build-model" />
                    <Route path="health" element={<HealthPage />} key="health" />
                    <Route path="sentinel" element={<SentinelPage />} key="sentinel" />
                    <Route path="langsmith" element={<LangSmithPage />} key="langsmith" />
                    <Route path="mage" element={<MagePage />} key="mage" />
                    <Route path="settings" element={<SettingsPage />} key="settings" />
                    <Route path="tenants" element={<TenantsPage />} key="tenants" />
                  </>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </>
        ) : (
          <LoginPage />
        )}
      </BrowserRouter>
    </CookiesProvider>
  );
}
